import React from 'react';
import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';
import { PrimeInfoContext } from 'context';
import { useShoppingBundleInfo } from 'hooks';
import {
  GET_PRIME_SITE_PROPERTIES,
  GET_USER_ACCOUNT,
} from './PrimeInfoProvider.query';

export const PrimeInfoProvider = ({ children }) => {
  const shoppingInfo = useShoppingBundleInfo();
  const userAccountResponse = useQuery(GET_USER_ACCOUNT, {
    variables: {
      request: {
        shoppingInfo,
      },
    },
  });
  const primeSitePropertiesResponse = useQuery(GET_PRIME_SITE_PROPERTIES);

  useLogFrontendApiError(userAccountResponse);
  useLogFrontendApiError(primeSitePropertiesResponse);

  return (
    <PrimeInfoContext.Provider
      value={{ userAccountResponse, primeSitePropertiesResponse }}
    >
      {children}
    </PrimeInfoContext.Provider>
  );
};
